/**
 * PIPELINE THUNKS — i cinque thunk CRUD standard, dal factory condiviso.
 */

import type { ServerListParams } from '@crm/shared';
import { createCrudThunks } from '../../store/createCrudThunks';
import { pipelineApi } from './pipelineApi';
import type { Pipeline } from './pipelineMappers';
import type {
  PipelineCreatePayload,
  PipelineUpdatePayload,
} from './pipelineTypes';

const thunks = createCrudThunks<
  Pipeline,
  PipelineCreatePayload,
  PipelineUpdatePayload,
  ServerListParams
>('pipelines', pipelineApi);

export const pipelineThunks = thunks;
export const {
  fetchAll: fetchPipelines,
  fetchOne: fetchPipeline,
  create: createPipeline,
  update: updatePipeline,
  remove: deletePipeline,
} = thunks;
